const inkAddProject = {
  controller: 'AddProjectController',
  template: require('./add-project.template.html'),
  bindings: {
    onComplete: '&'
  }
};

angular
  .module('inkfinder')
  .component('inkAddProject', inkAddProject);



// WEBPACK FOOTER //
// ./components/projects/project/add/add-project.component.js